import { render, staticRenderFns } from "./WebsitePhpService.vue?vue&type=template&id=7e9800d9&scoped=true&"
import script from "./WebsitePhpService.vue?vue&type=script&lang=js&"
export * from "./WebsitePhpService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9800d9",
  null
  
)

export default component.exports